
export * as BuyTicket from './buyticket';
export * as OrderProcessing from './orderprocessing';
export * as Survey from './survey';

/*
module.exports.BuyTicket = require('./buyticket');
module.exports.ChooseTicketPrice = require('./chooseticketprice');
module.exports.OrderProcessing = require('./orderprocessing');
module.exports.PaymentMethod = require('./paymentmethod');
module.exports.Survey = require('./survey');
module.exports.TicketSearch = require('./ticketsearch');
*/